import React from "react";
import { Building2, Users, Layers, GitMerge } from "lucide-react";

export default function MSP() {
  return (
    <div>
      <section className="pt-20 pb-16">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-orange-600 mb-5">MSP · Multi-tenant</div>
          <h1 className="font-display text-5xl lg:text-6xl font-bold tracking-tight leading-[1.02] ink">
            Manage email trust<br /><span className="font-serif italic font-normal">across customers.</span>
          </h1>
          <p className="mt-7 text-lg ink-soft leading-relaxed">
            Operate a multi-tenant email security practice with delegated administration, isolated reporting, and centralized alerts.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {[
            { icon: Building2, t: "Delegated admin", d: "Per-client roles with scoped permissions and read-only modes." },
            { icon: Layers, t: "White-label reporting", d: "Branded executive summaries — your logo, your story." },
            { icon: Users, t: "Centralized alerts", d: "Aggregate all tenant incidents into a single MSP feed." },
            { icon: GitMerge, t: "Multi-org dashboards", d: "Pivot across tenants without breaking isolation boundaries." },
          ].map(({ icon: Icon, t, d }) => (
            <div key={t} className="panel p-6">
              <div className="h-10 w-10 rounded-lg bg-orange-50 flex items-center justify-center mb-4">
                <Icon className="h-5 w-5 text-orange-600" strokeWidth={2} />
              </div>
              <div className="font-display font-bold ink">{t}</div>
              <p className="mt-2 text-sm ink-soft leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6">
          <div className="panel-shadow p-8">
            <div className="text-xs font-semibold uppercase tracking-[0.2em] text-orange-600 mb-5">MSP ops center</div>
            <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
              {["acme-corp.io", "globex.com", "initech.io", "umbrella.dev", "stark.industries"].map((d, i) => (
                <div key={d} className="panel-soft p-4">
                  <div className="font-mono text-xs ink-soft truncate">{d}</div>
                  <div className="mt-2 flex items-baseline gap-1">
                    <span className="font-display font-bold text-2xl ink">{80 + (i * 3) % 18}</span>
                    <span className="ink-muted text-xs">trust</span>
                  </div>
                  <div className="mt-1 text-[10px] font-mono ink-muted uppercase tracking-wider">{["p=none", "p=quarantine", "p=reject", "p=quarantine", "p=reject"][i]}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
